//----------------------------------------------------------------------------------------------------------------
// Copyright DeerSoft - 2019
//----------------------------------------------------------------------------------------------------------------

import CONST from "../webApp/CONST";
import { IsRunningAsBrowser } from "./rendererEnvironment";

type TChunkLoadFailureEvent = {
  reason?: unknown;
  error?: unknown;
  message?: unknown;
  target?: {
    src?: unknown;
    href?: unknown;
  };
  filename?: unknown;
};

type TChunkLoadFailure = {
  name?: unknown;
  message?: unknown;
  stack?: unknown;
};

const kChunkLoadRecoverySessionKey = "LightRight-ChunkLoadRecovery";
const kWebpackChunkAssetPattern = /(?:^|\/)bundle_[^/]+\.(?:css|js)(?:$|[?#])/i;
const kWebpackModuleCallFailurePattern =
  /Cannot read properties of undefined \(reading (?:'call'|"call")\)/i;
const kWebpackModuleStackPattern = /webpack\/bootstrap|bundle_[^/]+\.js/i;

function IsChunkLoadFailure(event: unknown) {
  const eventDetails: TChunkLoadFailureEvent =
    typeof event === "object" && event !== null
      ? (event as TChunkLoadFailureEvent)
      : {};
  const error = eventDetails.reason ?? eventDetails.error ?? event;
  const errorDetails: TChunkLoadFailure =
    typeof error === "object" && error !== null
      ? (error as TChunkLoadFailure)
      : {};
  const message =
    typeof error === "string"
      ? error
      : typeof errorDetails.message === "string"
        ? errorDetails.message
        : typeof eventDetails.message === "string"
          ? eventDetails.message
          : "";
  const target = eventDetails.target;
  const assetUrl =
    typeof target?.src === "string"
      ? target.src
      : typeof target?.href === "string"
        ? target.href
        : "";
  const hasWebpackModuleCallFailure =
    errorDetails.name === "TypeError" &&
    kWebpackModuleCallFailurePattern.test(message) &&
    ((typeof errorDetails.stack === "string" &&
      kWebpackModuleStackPattern.test(errorDetails.stack)) ||
      (typeof eventDetails.filename === "string" &&
        kWebpackChunkAssetPattern.test(eventDetails.filename)));

  return (
    errorDetails.name === "ChunkLoadError" ||
    /Loading (?:CSS )?chunk \S+ failed/i.test(message) ||
    kWebpackChunkAssetPattern.test(assetUrl) ||
    hasWebpackModuleCallFailure
  );
}

export function ReloadBrowserAfterChunkLoadFailure(event: unknown) {
  if (!IsRunningAsBrowser() || !IsChunkLoadFailure(event)) {
    return;
  }

  try {
    if (sessionStorage.getItem(kChunkLoadRecoverySessionKey) === CONST.BUILD) {
      return;
    }

    sessionStorage.setItem(kChunkLoadRecoverySessionKey, CONST.BUILD);
  } catch {
    return;
  }

  window.location.reload();
}
